import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from '@dexio/common';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private readonly configs: AppConfigService, private readonly http: HttpClient) { }

  getAll() {    
    return this.http
      .get(`${this.configs.get().apiUrl}/admin/users`);
  }
  getUserPermissions(userId: string) {    
    return this.http
      .get(`${this.configs.get().apiUrl}/admin/users/${userId}/permissions`);
  }
  updateUserPermissions(userId: string, data: any) {
    return this.http
      .post(`${this.configs.get().apiUrl}/admin/users/${userId}/permissions`, data);
  }
  createUser(data: any) {
    return this.http
      .post(`${this.configs.get().apiUrl}/admin/users`, data);
  }
  editUser(data: any) {
    return this.http
      .post(`${this.configs.get().apiUrl}/admin/users/${data.id}`, data);
  }
  refreshExternalData(userId: string) {
    return this.http
      .post(`${this.configs.get().apiUrl}/admin/users/${userId}/externaldata/refresh`, {});
  }
}
